<template>
  <section class="section">
    <div class="glass-container-main animate__animated animate__fadeIn">
      <div class="level mb-6">
        <div class="level-left">
          <div>
            <h1 class="title is-2 has-text-white mb-2">Gestión de Eventos</h1>
            <p class="subtitle is-6 has-text-grey-lighter">Configura y controla los eventos activos del sistema</p>
          </div>
        </div>
        <div class="level-right">
          <b-button 
            type="is-primary" 
            icon-left="plus" 
            class="is-rounded glass-btn-primary"
            size="is-medium"
            @click="abrirModal(null)"
          >
            Crear Evento
          </b-button>
        </div>
      </div>

      <div class="glass-table-container">
        <b-table 
          :data="eventos" 
          hoverable
          class="glass-table"
        >
          <b-table-column field="nombre" label="Nombre del Evento" v-slot="props" sortable>
            <span class="has-text-white has-text-weight-semibold">{{ props.row.nombre }}</span>
          </b-table-column>

          <b-table-column field="activo" label="Estado" v-slot="props" centered sortable>
            <b-tag 
              :type="props.row.activo == 1 ? 'is-success' : 'is-dark'"
              class="glass-tag"
            >
              <b-icon :icon="props.row.activo == 1 ? 'check-circle' : 'stop-circle'" size="is-small" class="mr-1" />
              {{ props.row.activo == 1 ? 'Activo' : 'Inactivo' }}
            </b-tag>
          </b-table-column>

          <b-table-column label="Acciones" v-slot="props" centered>
            <div class="buttons is-centered">
              <b-button
                type="is-info"
                size="is-small"
                icon-left="pencil"
                class="is-rounded glass-btn-action"
                @click="abrirModal(props.row)"
              >
                Editar
              </b-button>
              <b-button
                type="is-danger"
                size="is-small"
                icon-left="trash-can"
                class="is-rounded glass-btn-action-danger"
                @click="eliminar(props.row.id)"
              >
                Eliminar
              </b-button>
            </div>
          </b-table-column>

          <template #empty>
            <div class="has-text-centered py-6">
              <b-icon icon="calendar-blank" size="is-large" class="has-text-grey-light mb-4" />
              <p class="has-text-grey">No hay eventos registrados.</p>
            </div>
          </template>
        </b-table>
      </div>
    </div>

    <!-- Modal Form -->
    <b-modal 
      :active.sync="modalActivo" 
      has-modal-card 
      trap-focus
      :can-cancel="['escape', 'x', 'outside']"
      aria-role="dialog"
      aria-modal
    >
      <form-evento @registrar="registrarEvento" :eventoProp="eventoActual" @close="modalActivo = false" />
    </b-modal>

    <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false" />
  </section>
</template>

<script>
import FormEvento from './FormEvento.vue'
import HttpService from '../../Servicios/HttpService'

export default {
  name: 'EventosComponent',
  components: { FormEvento },
  data() {
    return {
      eventos: [],
      cargando: false,
      eventoActual: null,
      modalActivo: false
    }
  },
  mounted() {
    this.obtenerEventos();
    document.title = "Metropolitan - Eventos";
  },
  methods: {
    obtenerEventos() {
      this.cargando = true
      HttpService.registrar('eventos.php', { accion: 'obtener' })
        .then(res => {
          this.eventos = res || []
          this.cargando = false
        }).catch(() => { this.cargando = false; })
    },
    registrarEvento(evento) {
      this.cargando = true
      const accion = evento.id ? 'editar' : 'registrar'
      HttpService.registrar('eventos.php', { accion, evento })
        .then(res => {
          if (res) {
            this.$buefy.toast.open({
              type: 'is-success',
              message: evento.id ? 'Evento actualizado correctamente' : 'Nuevo evento creado',
              duration: 3000
            })
            this.eventoActual = null
            this.modalActivo = false
            this.obtenerEventos()
          }
        }).catch(() => { this.cargando = false; })
    },
    abrirModal(ev) {
      this.eventoActual = ev ? { ...ev } : null
      this.modalActivo = true
    },
    eliminar(id) {
      this.$buefy.dialog.confirm({
        title: 'Eliminar Evento',
        message: '¿Estás seguro de eliminar este evento? Esta acción no se puede deshacer.',
        confirmText: 'Eliminar',
        cancelText: 'Cancelar',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.cargando = true
          HttpService.registrar('eventos.php', { accion: 'eliminar', id })
            .then(res => {
              if (res) {
                this.$buefy.toast.open({
                  type: 'is-danger',
                  message: 'Evento eliminado',
                  duration: 2500
                })
                this.obtenerEventos()
              }
            }).catch(() => { this.cargando = false; })
        }
      })
    }
  }
}
</script>

<style scoped>
.glass-container-main {
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(15px);
  border-radius: 24px;
  padding: 40px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  min-height: 80vh;
}

.glass-btn-primary {
  background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%);
  border: none;
  font-weight: 600;
  box-shadow: 0 8px 16px rgba(59, 130, 246, 0.2);
}

.glass-table /deep/ .table {
  background: transparent !important;
  color: white !important;
}

.glass-table /deep/ .table thead th {
  background: rgba(255, 255, 255, 0.03) !important;
  color: #3b82f6 !important;
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
}

.glass-table /deep/ .table td {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  vertical-align: middle;
}

.glass-tag {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  color: #ccc !important;
}

.is-success.glass-tag {
  background: rgba(16, 185, 129, 0.1) !important;
  border: 1px solid rgba(16, 185, 129, 0.3) !important;
  color: #10b981 !important;
}

.glass-btn-action {
  background: rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.3);
  color: #60a5fa;
}

.glass-btn-action-danger {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: #f87171;
}

@media screen and (max-width: 768px) {
  .glass-container-main {
    padding: 20px;
  }
}
</style>
